import React, { useState } from "react";
import { IHarvestApplicationResponseModel } from "../../../typings/models/HarvestApplicationResponseModel";
import HarvestDetails from "../../HarvestDetails/HarvestDetails";
import { useNavigate } from "react-router-dom";
import moment from "moment";

interface GridRowProps {
  data: IHarvestApplicationResponseModel;
}

const HarvestDetailsGridRow: React.FC<GridRowProps> = ({ data }) => {
  let navigate = useNavigate();

  const handleAmendClick = (id: string) => {
    let path = `/harvest-details`;
    navigate(path, { state: { id: id, mode: "amend" } });
  };

  const handleExtendClick = (id: string) => {
    let path = `/harvest-details`;
    navigate(path, { state: { id: id, mode: "extend" } });
  };

  return (
    <tr>
      <td>{data.harvestDetailsRefNumber}</td>
      <td>{data.brooderMicrochipNumberString}</td>
      <td>{data.batchNumber}</td>
      <td>{data.uen}</td>
      <td>{data.companyName}</td>
      <td>{data.harvestDateString}</td>
      <td>{data.mobileNo}</td>
      <td>{data.email}</td>
      <td>{data.requestSubmissionDateString}</td>
      <td>
        <a href="#" onClick={() => handleAmendClick(data.harvestDetailsId)}>
          Amend{" "}
        </a>
        {data.extend && (
          <a href="#" onClick={() => handleExtendClick(data.harvestDetailsId)}>
            Extend
          </a>
        )}
      </td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default HarvestDetailsGridRow;
